import script from "./SOWReporting.vue?vue&type=script&lang=ts&setup=true"
export * from "./SOWReporting.vue?vue&type=script&lang=ts&setup=true"

import "./SOWReporting.vue?vue&type=style&index=0&id=412e051b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-412e051b"]])

export default __exports__